// Components==============
import {
    faBook,
    faBriefcase,
    faClock,
    faInfoCircle,
    faMapMarkerAlt,
    faUser,
    faImage,
} from '@fortawesome/pro-solid-svg-icons';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button';

import React from 'react';
import { getVacancyShorthand } from 'utilities/getVacancyShorthand';
import { getAvailabilityShorthand } from 'utilities/getAvailabilityShorthand';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import { getEmploymentShorthand } from 'utilities/getEmploymentShorthand';
import { interactiveScale } from 'utilities/framerAnimations';
import VacancyModal from '../VacancyModal/VacancyModal';
import './VacancyCard.module.scss';
// =========================

export default function VacancyCard({
    vacancy,
    color,
    backgroundColor,
    type = 'bar',
}) {
    const bottomData = [
        {
            icon: faUser,
            value: getVacancyShorthand(vacancy?.type),
        },
        {
            icon: faClock,
            value: getAvailabilityShorthand(vacancy.beschikbaarheid),
        },
        {
            icon: faBriefcase,
            value: getEmploymentShorthand(vacancy.dienstverband),
        },
        {
            icon: faMapMarkerAlt,
            value: vacancy.locatie,
        },
        {
            icon: faBook,
            value: vacancy.sector,
        },
    ];

    const openModal = useOpenUrlModal(`vacancy-popup/${vacancy?.id}`);

    return (
        <>
            <motion.div
                onClick={openModal}
                whileHover={{ scale: 1.02 }}
                initial={{ scale: 1 }}
                whileTap={{ scale: 0.98 }}
                styleName={`wrapper ${
                    backgroundColor === 'white' ? 'white ' : ''
                } ${type === 'card' ? 'card' : ''}`}
            >
                <div styleName="top">
                    <div styleName="image-wrapper">
                        {vacancy?.school?.logo ? (
                            <img
                                src={vacancy.school?.logo}
                                alt={vacancy.school?.name}
                            />
                        ) : (
                            <FontAwesomeIcon icon={faImage} />
                        )}
                    </div>
                    <div styleName="right">
                        <h3>{vacancy.name}</h3>
                        <p>{vacancy.school?.name}</p>
                    </div>
                    {type === 'bar' && (
                        <Button onClick={openModal} color={color? color.name : null}>
                            Meer informatie{' '}
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </Button>
                    )}
                </div>
                <div styleName="seperator" />
                <div styleName="bottom">
                    <div styleName="row">
                        {bottomData.map((data, i) => {
                            if (i === 0 && type === 'card') {
                                return;
                            }
                            return (
                                <div key={i} styleName="item">
                                    <FontAwesomeIcon icon={data.icon} />
                                    <p>{data.value}</p>
                                </div>
                            );
                        })}
                    </div>
                    {type === 'card' && (
                        <Button onClick={openModal} color={color? color.name : null}>
                            Meer informatie{' '}
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </Button>
                    )}
                </div>
            </motion.div>
            <AnimatePresence>
                <VacancyModal vacancy={vacancy} color={color} />
            </AnimatePresence>
        </>
    );
}
